import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class BlockedCprService {
  constructor(private apiService: ApiService) {}

  // Add single or multiple CPR numbers
  addBlockedCpr(data: { cprNumber: string, reason?: string }): Observable<any> {
    return this.apiService.postRequest('admin/blocked-cpr/add', data);
  }

  // Upload CSV file with CPR numbers
  uploadBlockedCpr(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.postRequest('admin/blocked-cpr/upload', formData);
  }

  // Get list of blocked CPR numbers with pagination and search
  getBlockedCprList(page: number = 1, limit: number = 10, search: string = ''): Observable<any> {
    let url = `admin/blocked-cpr/list?page=${page}&limit=${limit}`;
    
    if (search) {
      url += `&search=${search}`;
    }
    
    return this.apiService.getRequest(url);
  }

  // Get specific blocked CPR by ID
  getBlockedCprById(id: string): Observable<any> {
    return this.apiService.getRequest(`admin/blocked-cpr/${id}`);
  }

  // Update a blocked CPR
  updateBlockedCpr(id: string, data: { reason?: string, status?: number }): Observable<any> {
    return this.apiService.putRequest(`admin/blocked-cpr/${id}`, data);
  }

  // Delete a blocked CPR
  deleteBlockedCpr(id: string): Observable<any> {
    return this.apiService.deletRequest(`admin/blocked-cpr/${id}`);
  }
} 